import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import {
    createOrReplaceDevBoxAddOn,
    CreateOrReplaceDevBoxAddOnResponse,
} from '../../../data/services/data-plane-api/add-ons';
import { ClientError, FailureOperation, isFailureResponse } from '../../../models/common';
import {
    createOrReplaceDevBoxAddOn as createOrReplaceDevBoxAddOnActionCreator,
    createOrReplaceDevBoxAddOnError,
    createOrReplaceDevBoxAddOnFailed,
    createOrReplaceDevBoxAddOnSuccess,
} from '../../actions/add-ons/add-ons-action-creators';
import { CreateOrReplaceDevBoxAddOnAction } from '../../actions/add-ons/add-ons-actions';
import { getAccessToken } from '../../actions/identity/identity-action-creators';
import { GetAccessTokenForDevCenterDataPlanePayload } from '../../actions/identity/identity-actions';
import { createSagaError } from '../../effects/create-saga-error';
import { putAndAwait } from '../../effects/put-and-await';
import { rejectAction } from '../../effects/reject-action';
import { resolveAction } from '../../effects/resolve-action';
import { takeEvery } from '../../effects/take';

export function* createOrReplaceDevBoxAddOnSaga(action: CreateOrReplaceDevBoxAddOnAction): SagaIterator {
    const { meta, payload } = action;
    const { activityId } = meta ?? {};
    const { id, name, kind, hostingResourceName } = payload;

    try {
        const accessToken: string = yield putAndAwait(
            getAccessToken(GetAccessTokenForDevCenterDataPlanePayload(), meta)
        ); // For 0301 private preview API, only hostingResourceName is needed in the request body
        // The 'kind' is temporarily passed as the addOnType URL parameter
        // Note: In future API versions, 'kind' will be included in the request body
        const requestBody = {
            hostingResourceName,
        };

        const response: CreateOrReplaceDevBoxAddOnResponse = yield call(
            createOrReplaceDevBoxAddOn,
            id,
            name,
            kind,
            requestBody,
            accessToken,
            activityId
        );

        if (isFailureResponse(response)) {
            yield put(createOrReplaceDevBoxAddOnFailed({ failure: response, id }, meta));
            yield resolveAction(action, response);
            return;
        }

        yield put(createOrReplaceDevBoxAddOnSuccess({ id, result: response.data }, meta));
        yield resolveAction(action, response);
    } catch (err) {
        const error: ClientError = yield createSagaError(err, FailureOperation.CreateOrReplaceDevBoxAddOn);
        yield put(createOrReplaceDevBoxAddOnError({ error, id }, meta));
        yield rejectAction(action, error);
    }
}

export function* createOrReplaceDevBoxAddOnListenerSaga(): SagaIterator {
    yield takeEvery(createOrReplaceDevBoxAddOnActionCreator, createOrReplaceDevBoxAddOnSaga);
}
